module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_01 (2).b7dd73fd.png";